export default __webpack_public_path__ + "icon-like.cee2249d.png";